module.exports = __webpack_public_path__ + "img/prospect_logo_white.df17ddae.svg";